import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'concat' })
export class ConcatPipe implements PipeTransform {
  transform(value: string, args: string[]): any {
      
    if (!value) return value;
    let splitData = value.split(" ");
    let finalValue = "";
    for (let i = 0; i < splitData.length; i++) {
      if (finalValue)
        finalValue += args[0];
      finalValue += splitData[i];

    }
    return finalValue;
  }
}